export default __webpack_public_path__ + "static/media/manage-ams-active.61fc1b44.svg";